import {useContext, useEffect, useState} from 'react';

import {MenuItem} from '../../components';
import styles from './menuList.module.css';
import useScrollPos from '../../hooks/useScrollPos';

import baseContext from '../../store/base_context';
import locationContext from '../../store/location_context';
import useWindowSize from '../../hooks/useWindowSize';
import {useRouter} from 'next/router';
import Link from 'next/link';
import LocationSelector from '../../components/LocationSelector';

const MenuList = ({list}) => {
  const {top} = useScrollPos();
  const {width} = useWindowSize();
  const [splitNum, setSplitNum] = useState(0);
  const [categoryScrollTop, setCategoryScrollTop] = useState(0);
  const [activeType, setActiveType] = useState('');
  const [storeCode, setStoreCode] = useState('');
  const baseCtx = useContext(baseContext);
  const locationCtx = useContext(locationContext);
  const itemByType = list;

  const router = useRouter();

  const [filteredItemByType, setFilteredItemByType] = useState(itemByType);

  useEffect(() => {
    const allGrids = document
        .querySelectorAll('[class*=app__menulist_right_item_menus]');

    if (allGrids.length > 0) {
      setSplitNum(Object.keys(allGrids).map((index) =>
        window.getComputedStyle(allGrids[index])
            .gridTemplateColumns.split(' ').length)
          .reduce((a, b) => Math.max(a, b)));
    }
  }, [width]);

  useEffect(() => {
    const imageBanner = document.getElementById('image_banner');
    setCategoryScrollTop(imageBanner.offsetTop + imageBanner.clientHeight);

    setStoreCode(router?.query?.storeCode);
  }, []);

  useEffect(() => {
    if (top + 50 >= categoryScrollTop) {
      baseCtx.updateShowHeader(false);
    } else {
      baseCtx.updateShowHeader(true);
    }
  }, [top]);

  const typeClickHandler = (type) => {
    const height = document
        .getElementById(type.replace(/\s/g, '_'))
        .getBoundingClientRect()
        .top;
    window.scrollBy({
      top: height - 200,
      behavior: 'smooth',
    });
    setActiveType(type);
  };

  const typeList =
      [
        ...new Set(
            filteredItemByType
                .map((category) => category.categoryName)
        ),
      ];

  return (
    <div className={styles.app__menulist_wrapper}>
      <div
        className={styles.category_wrapper}
        id={`categorySection`}>
        {typeList.map((type) => {
          return (
            <div
              key={type}
              className={`${styles.category_option} ${type === activeType ?
                  styles.category_option_selected : ''}`}>
              <a
                className={`custom__clickable_link`}
                onClick={typeClickHandler.bind(0, type)}>
                <span>
                  {type}
                </span>
              </a>
            </div>
          );
        })}
      </div>
      <div
        className={styles.app__menulist_right}>
        {storeCode &&
            <div className={styles.app__menulist_right_header_button}>
              <Link href={`/${storeCode}`} className={`custom__button`}>
                Show Menu PDF
              </Link>
            </div>
        }
        <div className={styles.app__menulist_right_header}>
          <div className={styles.app__menulist_right_header_title}>
            {storeCode ?
            `*The price will fluctuate according to the seafood market price` :
            <>
              {locationCtx.location ?
              <>
                *Click&nbsp;
                <Link
                  href={`/locations/${locationCtx.location.storeCode}/menu`}
                  passHref>
                  here
                </Link>
                &nbsp;to check prices in {locationCtx.location.title}
              </> :
              <>
                *Click&nbsp;
                <a
                  onClick={() => {
                    baseCtx.updateModal(<LocationSelector />);
                  }}>
                  here
                </a>
                &nbsp;to check detailed info & prices in your local store
              </>}
            </>}
          </div>
        </div>
        {filteredItemByType
            .map((type) => {
              return type?.foodItems?.length > 0 ? (
                  <div
                    className={styles.app__menulist_right_item_container}
                    key={type.categoryId}
                    id={type.categoryName.replace(/\s/g, '_')}>
                    <div className={styles.app__menulist_right_item_title}>
                      <span
                        className={type.categoryName === activeType?
                            styles.app__menulist_left_options_selected : ''}
                      >{type.categoryName}</span>
                    </div>
                    <div
                      className={styles.app__menulist_right_item_menus}>
                      {type.foodItems.map((foodItem) => (
                        <MenuItem
                          item={foodItem}
                          key={foodItem.PK}
                          setItems={setFilteredItemByType}
                        />
                      ))}
                      {type.foodItems.length < splitNum ?
                        [...Array(splitNum - type.foodItems.length).keys()]
                            .map((index) => {
                              return <div key={index}/>;
                            }
                            ) : ''}
                    </div>
                  </div>
                ) : '';
            })}
      </div>
    </div>
  );
};

export default MenuList;
